<div class="table-loader-overlay table-overlay-margin" *ngIf="loading">
  <div class="overlay-spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</div>

<h2 class="page-header">Drukwerk</h2>

<div class="flex-table" *ngIf="printProductionItems">
  <div class="flex-header-row">
    <div class="flex-table-cell flex-1 flex-table-cell-id">
      <div>ID</div>
      <filter-input
        [filterObject]="getFilterForKey('id')"
        [isDate]="false"
        (click)="$event.preventDefault() && $event.stopPropagation()"
        (toggleFilterEmitter)="toggleFilter($event)"
        (filterValueChanged)="onFilterValueChange($event)"
      ></filter-input>
    </div>
    <div class="flex-table-cell flex-3">
      Type
      <filter-dropdown
        [keyValueMap]="typeOptions"
        [filterObject]="getFilterForKey('type')"
        (toggleFilterEmitter)="toggleFilter($event)"
        (filterValueChanged)="onFilterValueChange($event)"
        placeholder="Selecteer Type"
      ></filter-dropdown>
    </div>

    <div class="flex-table-cell flex-2">Materiaal</div>
    <div class="flex-table-cell flex-3">
      Afmetingen
      <filter-dropdown
        [keyValueMap]="dimensionOptions"
        [filterObject]="getFilterForKey('dimensions')"
        (toggleFilterEmitter)="toggleFilter($event)"
        (filterValueChanged)="onFilterValueChange($event)"
        placeholder="Selecteer Afmetingen"
      ></filter-dropdown>
    </div>
    <div class="flex-table-cell flex-3">
      Drukwijze
      <filter-dropdown
        [keyValueMap]="printMethodOptions"
        [filterObject]="getFilterForKey('printMethod')"
        (toggleFilterEmitter)="toggleFilter($event)"
        (filterValueChanged)="onFilterValueChange($event)"
        placeholder="Selecteer Drukwijze"
      ></filter-dropdown>
    </div>
    <div class="flex-table-cell flex-2">Aantal kleuren</div>
    <div class="flex-table-cell flex-1">Filmkost</div>
    <div class="flex-table-cell flex-1">Zeefwissel</div>

    <div class="flex-table-cell flex-1" *ngFor="let header of BulkPriceHeaders">
      {{ header }}
    </div>

    <div class="flex-table-cell flex-1"></div>
  </div>

  <div class="flex-table-row" *ngFor="let item of printProductionItems">
    <div class="flex-table-cell flex-1 clickable" (click)="editItem(item)">
      {{ item.id }}
    </div>
    <div class="flex-table-cell flex-3 clickable" (click)="editItem(item)">
      {{ getEnumDisplayValue(PrintProductionType, item.type) }}
    </div>
    <div class="flex-table-cell flex-2 clickable" (click)="editItem(item)">
      {{ getEnumDisplayValue(MaterialType, item.material) }}
    </div>
    <div class="flex-table-cell flex-3 clickable" (click)="editItem(item)">
      {{ getEnumDisplayValue(DimensionsType, item.dimensions) }}
    </div>
    <div class="flex-table-cell flex-3 clickable" (click)="editItem(item)">
      {{ getEnumDisplayValue(PrintMethodType, item.printMethod) }}
    </div>
    <div class="flex-table-cell flex-2 clickable" (click)="editItem(item)">
      {{ getEnumDisplayValue(NbColorsType, item.nbColors) }}
    </div>
    <div class="flex-table-cell flex-1 clickable" (click)="editItem(item)">
      {{ item.filmCost }}
    </div>
    <div class="flex-table-cell flex-1 clickable" (click)="editItem(item)">
      {{ item.sieveChange }}
    </div>
    <div
      class="flex-table-cell flex-1"
      (click)="editItem(item)"
      *ngFor="let header of BulkPriceHeaders"
    >
      {{
        getBulkPrice(item, header)
          | currency : 'EUR' : 'symbol' : '1.2-2' : 'nl'
      }}
    </div>
    <div class="flex-table-cell flex-1">
      <div class="d-flex">
        <span class="padding-right clickable" (click)="editItem(item)">
          <mat-icon>edit</mat-icon>
        </span>
        <span class="clickable" (click)="deleteItem(item)">
          <mat-icon>delete</mat-icon>
        </span>
      </div>
    </div>
  </div>
</div>
<div class="pull-left clickable" (click)="createNewPrintProduction()">
  <mat-icon svgIcon="add"></mat-icon>
</div>
<mat-paginator
  [length]="totalItems"
  [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="true"
></mat-paginator>
